import 'slick-carousel';

$(document).ready(function () {
	$('.mainpage .numbers .numbers__list').slick({
		arrows: true,
		dots: false,
		fade: true,
		autoplay: false,
		adaptiveHeight: true,
		// autoplaySpeed: 8000,
		// speed: 1000,
		asNavFor: '.numbers .tabs__list',
		responsive: [
			{
				breakpoint: 767,
				settings: {
					autoplay: false,
					fade: false,
					swipe: true,
					speed: 200
				}
			},
			{
				breakpoint: 400,
				settings: {
					autoplay: false,
					fade: false,
					swipe: true,
					speed: 200
				}
			}
		]
	});

	$('.mainpage .numbers .tabs__list').slick({
		arrows: false,
		dots: false,
		fade: true,
		autoplay: true,
		autoplaySpeed: 8000,
		speed: 1000,
		variableWidth: true,
		slidesToShow: 10,
		asNavFor: '.numbers .numbers__list',
		focusOnSelect: true,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1
				}
			},
			{
				breakpoint: 400,
				settings: {
					slidesToShow: 1,
				}
			}
		]
	});



	$('.numbers__entry .entry__photo .btn').click(function (e) {
		e.preventDefault();

		$(this).prev('.gallery__list').find('.gallery__entry:first-child .gallery__lnk')[0].click();
	});


	//$('.numbers__entry .price__count').html(GG.formatNumberWithSpaces($('.numbers__entry .price__count').html()));

	if($('.numbers__cards .cards__entry .entry__title span').length) {
		$('.numbers__cards .cards__entry .entry__title span').each(function () {
			$(this).html(GG.formatNumberWithSpaces($(this).html()));
		});
	}


	if($('.numbers__cards').length) {
		$('.cards__list').slick({
			arrows: true,
			dots: false,
			slidesToShow: 3,
			rows: 0,
			responsive: [
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 1
					}
				},
				{
					breakpoint: 400,
					settings: {
						slidesToShow: 1,
						arrows: false,
						dots: true
					}
				}
			]
		});
	}

	$('.advantages__video .video__toggle').click(function (e) {
		e.preventDefault();

		let videoUrl = $(this).data('video-url');

		$('#popup-video iframe').attr('src', videoUrl);
		GG.togglePopup('popup-video');
	});

	GG.callback('popupClosed.video',
		function(element){
			$(element).find('iframe').attr('src', '');
		}
	);
});
